import { render, staticRenderFns } from "./consultationList.vue?vue&type=template&id=b2a570fa&scoped=true"
import script from "./consultationList.vue?vue&type=script&lang=js"
export * from "./consultationList.vue?vue&type=script&lang=js"
import style0 from "./consultationList.vue?vue&type=style&index=0&id=b2a570fa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2a570fa",
  null
  
)

export default component.exports